import React from 'react';

// Material UI
import { Box, ListItem, ListItemText, IconButton } from '@material-ui/core';

type Props = {
  title: string;
  label: string;
  className?: string;
  classes?: {
    root?: string;
    listItem?: string;
    listItemText?: string;
    iconButton?: string;
  };
  icon?: React.ReactElement | React.ReactNode | undefined;
  handleClick: () => void;
};

// List filter options on left
const ListItemComponent: React.FC<Props> = ({
  title,
  label,
  icon,
  className,
  classes,
  handleClick,
}) => (
  <Box
    display='flex'
    width='100%'
    justifyContent='space-between'
    alignItems='center'
    onClick={handleClick}
    flexWrap='nowrap'
    className={classes?.root}>
    <ListItem button className={[className, classes?.listItem].join(' ')}>
      <ListItemText
        className={classes?.listItemText}
        primary={title}
        onClick={() => {
          if (!icon && handleClick instanceof Function) handleClick();
        }}
      />
    </ListItem>
    {icon && handleClick instanceof Function && (
      <IconButton edge='end' aria-label={label} className={classes?.iconButton}>
        {icon}
      </IconButton>
    )}
  </Box>
);

export default ListItemComponent;
export { ListItemComponent };
